import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { CompaniesGridController } from '../controller/CompaniesGridController';
import { CompanyTypeData } from '../../../company/types/company-type-data';

export class CompaniesGridWebComponent extends BaseWebComponentElement {
  public controller: CompaniesGridController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CompaniesGridController,
    });
  }

  public set companyTypes(companyTypes: CompanyTypeData[]) {
    this.setAttribute('data-company-types', JSON.stringify(companyTypes));
  }

  public get companyTypes(): CompanyTypeData[] {
    const value = this.getAttribute('data-company-types');
    return value ? JSON.parse(value) : [];
  }

  public async reload() {
    await this.controller?.view.dom.$grid.controller?.handleGridItemsLoad(true);
  }

  public closeSettingsSideMenu() {
    this.controller?.view.dom.$grid.closeSettingsSideMenu();
  }
}
